<template>
    <div class="form">
        <el-form style="margin:20px;width:60%;min-width:600px;" label-width="180px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单号">
                <span>{{Form.SendCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单状态">
                <span>{{Form.SendStatusName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="代理商">
                <span>{{Form.AgentCode}}{{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单下单时间">
                <span>{{Form.SendTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单下单人">
                <span>{{Form.AddUserName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货情况">
                <span>{{Form.DeliveryStatusName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="商品" v-show="Form.ListGoods!=''" style="width:900px">
                <el-table :data="Form.ListGoods" border style="width: 80%;  margin-left: 25px;" >
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="订单数">
                    </el-table-column>
                   <!-- <el-table-column prop="UnSendNum" label="未通知数">
                    </el-table-column>-->
                    <el-table-column  prop="SendNum"  label="通知数">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="赠品" v-show="Form.GiftGoods!=''" style="width:900px">
                <el-table :data="Form.GiftGoods" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="订单数">
                    </el-table-column>
                    <!--<el-table-column prop="UnSendNum" label="未通知数">
                    </el-table-column>-->
                    <el-table-column prop="SendNum" label="通知数">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="要求发货时间">
                <span>{{Form.RequireSendDate}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单审核时间">
                <span>{{Form.AuditTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="收货人及联系方式">
                <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="支付方式">
                <span>{{Form.PayModeName}}</span>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import NProgress from 'nprogress'
    import {
            GetERP_SendGoodsById
    } from '../../api/sendGoodsApi.js'
    import {
            util
    } from '../../common/js/util.js';
    module.exports = {
        data(){
        return {
            Form:{}
        }
    },
    created: function () {
        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
            let _session=util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                Id: this.$route.query.Id
            };
            GetERP_SendGoodsById(para).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    let Data = res.data.Data;
                    this.Form = [];
                    this.Form = Data;
                }
            })
        }
    }
    }
</script>
<style scoped>
    span{
        margin-left: 25px;
    }
</style>


// WEBPACK FOOTER //
// AuditViewSendGoods.vue?551c45f2